import { gql } from "@apollo/client"

export const GET_ALL_COUNTRY = gql`
  query getAllCountry {
    country {
      code
      name
    }
  }
`

export const GET_TRANCHES_LOCATION = gql`
  query getTranchesLocation($campaignIds: [uuid!]) {
    campaign(where: { id: { _in: $campaignIds } }) {
      id
      tranches {
        id
        start_date
        end_date
        recruitment_end_date
        age_groups {
          age_category {
            code
            name
          }
          category_code
        }
        cash_usd_cents
        deliverable_specs {
          content_type {
            code
            name
          }
          due_date
          quantity
          requirement_description
          title
        }
        genders {
          category_code
          gender {
            code
            description
          }
        }
        max_follower_size
        min_follower_size
        number_kols
        product_categories {
          category_code
          product_category {
            name
          }
        }
        product_value_usd_cents
        requirements
        social_platforms {
          category_code
          social_platform {
            name
          }
        }
        country {
          code
          name
        }
      }
    }
  }
`

export const GET_CAMPAIGNS = gql`
  query GetCampaigns($name: String) {
    campaign(where: { name: { _ilike: $name } }, order_by: { created_at: desc }) {
      id
      name
      product_name
      budget_cash_usd_cents
      exchange_rates
      display_currency
      created_at
      client_profile {
        id
        company_name
      }
      tranches {
        id
        start_date
        end_date
        recruitment_end_date
        age_groups {
          age_category {
            code
            name
          }
          category_code
        }
        cash_usd_cents
        deliverable_specs {
          content_type {
            code
            name
          }
          due_date
          quantity
          requirement_description
          title
        }
        genders {
          category_code
          gender {
            code
            description
          }
        }
        max_follower_size
        min_follower_size
        number_kols
        product_categories {
          category_code
          product_category {
            name
          }
        }
        product_value_usd_cents
        requirements
        social_platforms {
          category_code
          social_platform {
            name
          }
        }
        country {
          code
          name
        }
      }
    }
  }
`
